import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, LOCALE_ID } from '@angular/core';
import {DatePipe, DecimalPipe} from '@angular/common';
import { ConverterUtils } from './converter.utils';
declare let pdfMake: any;
const apiUrl = 'assets/templatePDFMake/';


@Injectable()
export class DocumentExportService {

  private decimalPipe: DecimalPipe;

  private listPDFArr = [];

  private currencyUnit = {
    'locale': 'fr',
    'majorUnit': 'dinar',
    'majorUnitPlural': 'dinars',
    'minorUnit': 'millime',
    'minorUnitPlural': 'millimes',
    'partsSeparator': 'et',
    'comma': ',',
    'defaultUnit': true
  };

  constructor(
    private datePipe: DatePipe,
    private converterUtils: ConverterUtils,
    decimalPipe: DecimalPipe,
    private http: HttpClient,
    @Inject(LOCALE_ID) public locale: string
  ) {
    this.decimalPipe = decimalPipe;
  }

  getListPdf() {
    return this.listPDFArr;
  }

  resetListPdf() {
     this.listPDFArr = [];
  }

  loadConfig(filename: string) {
    const url = `${apiUrl}/` + filename;
    return this.http.get<any>(url);
  }

  exportBulletinAnalyseBDur(documentType: string, document, print = false, base64 = false) {
    let jsonFile = 'bulletinAnalyseBDur.json';
    if (documentType === 'BulletinAnalyseBDur') {
      jsonFile = 'bulletinAnalyseBDur.json';  // to fix
    }

    this.loadConfig(jsonFile)
      .subscribe(docDefinition => {

        // docDefinition.header.columns[1].text = 'La Graine des Graines Tunisienne GGT';
        const dateAnalyse = this.datePipe.transform(document.dateAnalyse, 'dd-MM-yyyy');
        const num = document.demandeAnalyse.reference;
        const center = document.demandeAnalyse.centre.name;
        const produit = document.demandeAnalyse.product.name;

        const echantillonTotal = document.echantillonGlobal_R;
        const echantillonReduit = document.echantillonReduit_R2;
        const echantillonReduit1 = document.echantillonReduit_R1;
        const echantillonPropre = document.blEchPropore;
        const demande = document.demandeAnalyse.reference;
        const agriculteur = document.demandeAnalyse.farmer.firstName + ' ' + document.demandeAnalyse.farmer.lastName;
        const CIN = document.demandeAnalyse.farmer.cin;
        const coefficient_C = document.coefficient_C;
        const bordereau = document.demandeAnalyse && document.demandeAnalyse.bordereauDemandeAnalyseNum ? document.demandeAnalyse.bordereauDemandeAnalyseNum : '';
        let qte = 0;
        for (let i = 0; i < document.demandeAnalyse.bonReceptionList.length; i++) {
          qte += document.demandeAnalyse.bonReceptionList[i].quantity;
        }

        const bleDur51 = document.bleDur51;
        const bleDur59 = document.bleDur59;
        const bleDur52 = document.bleDur52;
        const taux52 = Number(((bleDur52 / echantillonPropre) * 100).toFixed(3)) ;
        const bleDur53 = document.bleDur53;
        const taux53 = Number((bleDur53 * document.coefficient_C).toFixed(3)) ;
        const bleDur54 = document.bleDur54;
        const taux54 = Number((bleDur54 * coefficient_C).toFixed(3)) ;
        const bleDur60 = Number((document.bleDur60).toFixed(3)) ;
        const taux60 = Number((bleDur60 * coefficient_C).toFixed(3)) ;
        const bleDur62 = document.bleDur62;
        const taux62 = Number((bleDur62 * coefficient_C).toFixed(3)) ;
        const bleDur61 = document.bleDur61;
        const taux61 = Number((bleDur61 * coefficient_C).toFixed(3)) ;
        const bleDur63 = document.bleDur63;
        const taux63 = Number((bleDur63 * coefficient_C).toFixed(3)) ;
        const bleDur65 = document.bleDur65;
        const taux65 = Number((bleDur65 * coefficient_C).toFixed(3)) ;
        const bleDur66 = document.bleDur66;
        const taux66 = Number((bleDur66 * coefficient_C).toFixed(3));
        const bleDur70 = document.bleDur70;
        const taux70 = Number((bleDur70 * coefficient_C).toFixed(3)) ;
        const bleDur71 = document.bleDur71;
        const taux71 = Number((bleDur71 * coefficient_C).toFixed(3)) ;
        const bleDur64 = document.bleDur64;
        const taux64 = Number((bleDur64 * coefficient_C).toFixed(3)) ;
        const bleDur72 = document.bleDur72;
        const taux72 = Number((bleDur72 * coefficient_C).toFixed(3)) ;

        const bleDur80 = Number((document.bleDur80).toFixed(3)) ;
        const taux80 = Number(((document.bleDur81 +
            document.bleDur82 + document.bleDur83 +
            document.bleDur84 + document.bleDur85 +
            document.bleDur86 + document.bleDur88 + document.bleDurBalle +
            document.bleDur87) * document.coefficient_C + document.tauxGrosseImpuretes + (document.bleDur78 * 100 / document.echantillonReduit_R1) +
          document.bulletinAnalyse.bleDur89 + document.bulletinAnalyse.bleDur79).toFixed(3));

        const bleDur81 = document.bleDur81;
        const taux81 = Number((bleDur81 * coefficient_C).toFixed(3)) ;
        const bleDur82 = document.bleDur82;
        const taux82 = Number((bleDur82 * coefficient_C).toFixed(3)) ;
        const bleDur83 = document.bleDur83;
        const taux83 = Number((bleDur83 * coefficient_C).toFixed(3)) ;
        const bleDur84 = document.bleDur84;
        const taux84 = Number((bleDur84 * coefficient_C).toFixed(3)) ;
        const bleDur85 = document.bleDur85;
        const taux85 = Number((bleDur85 * coefficient_C).toFixed(3)) ;
        const bleDur86 = document.bleDur86;
        const taux86 = Number((bleDur86 * coefficient_C).toFixed(3)) ;
        const bleDur88 = document.bleDur88;
        const taux88 = Number((bleDur88 * coefficient_C).toFixed(3)) ;
        const bleDur89 = document.bleDur89;
        const taux89 = Number((bleDur89 * coefficient_C).toFixed(3)) ;
        const bleDur87 = document.bleDur87;
        const taux87 = Number((bleDur87 * coefficient_C).toFixed(3)) ;
        const bleDur78 = document.bleDur78;
        const taux78 = Number(((bleDur78 / document.echantillonReduit_R1) * 100).toFixed(3)) ;
        const bleDur76 = document.bleDurBalle;
        const taux76 = Number(((bleDur76 * coefficient_C)).toFixed(3)) ;
        const bleDur77 = document.bleDur77;
        const taux77 = Number(((bleDur77 * coefficient_C)).toFixed(3)) ;
        const bleDur79 = document.bleDur79;
        const taux79 = Number(((bleDur79 * coefficient_C) * 100).toFixed(3)) ;
        const bleDur90 = Number((document.impurtesTotal).toFixed(3)) ;
        const taux90 = Number((bleDur90 * coefficient_C).toFixed(3)) ;

        const totalBonif = Number(document.bulletinAnalyse.totalBonification.toFixed(3));
        const totalRefact = Number(document.bulletinAnalyse.totalRefaction.toFixed(3));
        const bilanAnalyse = Number((totalBonif + totalRefact).toFixed(3));
        const prixBase = document.demandeAnalyse.product.startingPrice;
        const prixUnitaire = document.bulletinAnalyse.prixUnitaire;

        let grosseImpuretes = document.mesureGrosseImpuretes;

        grosseImpuretes = grosseImpuretes ? grosseImpuretes.toFixed(1) : Number(0).toFixed(1);

        let tauxgrosseImpuretes = document.tauxGrosseImpuretes;
        tauxgrosseImpuretes = tauxgrosseImpuretes ? tauxgrosseImpuretes.toFixed(2) : Number(0).toFixed(2);


        const bonif59 = document.bulletinAnalyse.bleDur59;
        const bonif51 = document.bulletinAnalyse.bleDur51;
        const refact53 = document.bulletinAnalyse.bleDur53;
        const refact54 = document.bulletinAnalyse.bleDur54;
        const refact52 = document.bulletinAnalyse.bleDur52;
        const refact60 = document.bulletinAnalyse.bleDur60;
        const refact61 = document.bulletinAnalyse.bleDur61;
        const refact62 = document.bulletinAnalyse.bleDur62;
        const refact63 = document.bulletinAnalyse.bleDur63;
        const refact64 = document.bulletinAnalyse.bleDur64;
        const refact65 = document.bulletinAnalyse.bleDur65;
        const refact66 = document.bulletinAnalyse.bleDur66;
        const refact70 = document.bulletinAnalyse.bleDur70;
        const refact71 = document.bulletinAnalyse.bleDur71;
        const refact72 = document.bulletinAnalyse.bleDur72;
        const refact76 = document.bulletinAnalyse.bleDurBalle;
        const refact77 = document.bulletinAnalyse.bleDur77;
        const refact79 = document.bulletinAnalyse.bleDur79;
        const refact80 = document.bulletinAnalyse.bleDur80;
        const refact81 = document.bulletinAnalyse.bleDur81;
        const refact82 = document.bulletinAnalyse.bleDur82;
        const refact83 = document.bulletinAnalyse.bleDur83;
        const refact84 = document.bulletinAnalyse.bleDur84;
        const refact85 = document.bulletinAnalyse.bleDur85;
        const refact86 = document.bulletinAnalyse.bleDur86;
        const refact87 = document.bulletinAnalyse.bleDur87;
        const refact78 = document.bulletinAnalyse.bleDur78;
        const refact90 = document.bulletinAnalyse.bleDur90;
        const tauxdeBonif = totalBonif;
        const tauxdeRefact = totalRefact;

    const critereValues = [];
    critereValues.push(
      [51, 'Poids Spécifique PS', 'Refaction', 'Oui', bleDur51, bleDur51, bonif51],
      [59, 'Humidité', 'Bonification', 'Oui', bleDur59, bleDur59, bonif59],
      [52, 'Grains Métadinés', 'Refcation', 'Oui', bleDur52, taux52, refact52],
      [50, 'Grosses Impurétés', 'Refcation', 'Oui', grosseImpuretes, tauxgrosseImpuretes, '--'],
      [53, 'Grains Cassés ', 'Refcation', 'Oui', bleDur53, taux53, refact53],
      [54, 'Graines germées ', 'Refcation', 'Oui', bleDur54, taux54, refact54],
      [60, 'Total Impr grains ', 'Refcation', 'Oui', bleDur60, taux60, refact60],
      [61, ' Graines chauffées ', 'Refcation', 'Oui', bleDur61, taux61, refact61],
      [62, ' Autres céreales ', 'Refcation', 'Oui', bleDur62, taux62, refact62],
      [63, 'Graines maigres ', 'Refcation', 'Oui', bleDur63, taux63, refact63],
      [64, 'Coloration des germes ', 'Refcation', 'Oui', bleDur64, taux64, refact64],
      [65, 'Graines punaisées ', 'Refcation', 'Oui', bleDur65, taux65, refact65],
      [66, 'Graines attaquées ', 'Refcation', 'Oui', bleDur66, taux66, refact66],
      [70, 'Total Gr mouchetés ', 'Refcation', 'Oui', bleDur70, taux70, refact70],
      [71, 'Graines fusariés ', 'Refcation', 'Oui', bleDur71, taux71, refact71],
      [72, 'Grains mouchetés ', 'Refcation', 'Oui', bleDur72, taux72, refact72],
      [76, 'Balle', 'Refcation', 'Oui', bleDur76, taux76, refact76],
      [77, 'Autres Impuretés ', 'Refcation', 'Oui', bleDur77, taux77, refact77],
      [78, 'Impuretés propre ', 'Refcation', 'Oui', bleDur78, taux78, refact78],
      [79, 'Insectes mortes ', 'Refcation', 'Oui', bleDur79, taux79, refact79],
      [80, 'Totales Imp diverses ', 'Refcation', 'Oui', bleDur80, taux80, refact80],
      [81, 'Ail ', 'Refcation', 'Oui', bleDur81, taux81, refact81],
      [82, 'Fenugrec ', 'Refcation', 'Oui', bleDur82, taux82, refact82],
      [83, 'Ivraie ', 'Refcation', 'Oui', bleDur83, taux83, refact83],
      [84, 'Mellilot ', 'Refcation', 'Oui', bleDur84, taux84, refact84],
      [85, 'Graines brulées ', 'Refcation', 'Oui', bleDur85, taux85, refact85],
      [86, 'Ergot ', 'Refcation', 'Oui', bleDur86, taux86, refact86],
      [87, 'Grianes Etrangères ', 'Refcation', 'Oui', bleDur87, taux87, refact87],
      [88, 'Graines Avariés ', 'Refcation', 'Oui', bleDur88, taux88, '--'],
      [89, 'Graines cariées ', 'Refcation', 'Oui', bleDur89, taux89, '--'],
      [90, 'Impuretés totales ', 'Refcation', 'Oui', bleDur90, taux90, refact90],
    );

        critereValues.forEach(e => {
            if (e[4] != null && e[4] !== 0) {
              docDefinition.content[4].table.body.push(
                [{'text': e[0], 'style': 'tableContent'}, {'text': e[1], 'style': 'tableContent'},
                  {'text': e[2], 'style': 'tableContent'}, {'text': e[3], 'style': 'tableContent'},
                  {'text': e[4], 'style': 'tableContent'}, {'text': e[5], 'style': 'tableContent'},
                  {'text': e[6]}]
              );
            }
          }

        );

        let optionStr = JSON.stringify(docDefinition);

        optionStr = this.unsafeRedactName(optionStr, 'dateAnalyse' , dateAnalyse);
        optionStr = this.unsafeRedactName(optionStr, 'num' , num);
        optionStr = this.unsafeRedactName(optionStr, 'center' , center);
        optionStr = this.unsafeRedactName(optionStr, 'produit' , produit);
        optionStr = this.unsafeRedactName(optionStr, 'demande' , demande);
        optionStr = this.unsafeRedactName(optionStr, 'qte' , qte ? qte.toFixed(2) : 0);
        optionStr = this.unsafeRedactName(optionStr, 'agriculteur' , agriculteur);
        optionStr = this.unsafeRedactName(optionStr, 'CIN' , CIN);
        optionStr = this.unsafeRedactName(optionStr, 'bordereau' , bordereau);
        optionStr = this.unsafeRedactName(optionStr, 'echantillonTotal' , echantillonTotal);
        optionStr = this.unsafeRedactName(optionStr, 'echantillonReduit' , echantillonReduit);
        optionStr = this.unsafeRedactName(optionStr, 'echantillonPropre' , echantillonPropre);
        optionStr = this.unsafeRedactName(optionStr, 'echantillonReduit1' , echantillonReduit1);
        optionStr = this.unsafeRedactName(optionStr, 'totalBonif' , totalBonif);
        optionStr = this.unsafeRedactName(optionStr, 'totalRefact' , totalRefact);
        optionStr = this.unsafeRedactName(optionStr, 'tauxdeBonif' , tauxdeBonif);
        optionStr = this.unsafeRedactName(optionStr, 'tauxdeRefact' , tauxdeRefact);
        optionStr = this.unsafeRedactName(optionStr, 'bilanAnalyse' , bilanAnalyse);
        optionStr = this.unsafeRedactName(optionStr, 'prixBase' , prixBase);
        optionStr = this.unsafeRedactName(optionStr, 'prixUnitaire' , prixUnitaire);



        // console.log(optionStr);
        docDefinition = JSON.parse(optionStr);

        if (print) {
          pdfMake.createPdf(docDefinition).print();
        } else {
          if (base64) {
            const pdfDocGenerator = pdfMake.createPdf(docDefinition);
            pdfDocGenerator.getDataUrl((dataUrl) => {
              //$('#pdf').attr('data', dataUrl );
              //this.listPDFArr.push(dataUrl);
              this.listPDFArr.push(docDefinition);
            });
          } else {
            pdfMake.createPdf(docDefinition).download(documentType + '.pdf');
          }
        }
      }, err => {
        // this.toastr.error(`Une erreur s'est produite lors de l'enregistrement` + ': ' + err,  `Erreur`);
      });
  }
  exportBulletinAnalyseBTendre(documentType: string, document, print = false, base64 = false) {
    let jsonFile = 'bulletinAnalyseBTendre.json';
    if (documentType === 'BulletinAnalyseBTendre') {
      jsonFile = 'bulletinAnalyseBTendre.json';  // to fix
    }

    this.loadConfig(jsonFile)
      .subscribe(docDefinition => {

        // docDefinition.header.columns[1].text = 'La Graine des Graines Tunisienne GGT';

        const dateAnalyse = this.datePipe.transform(document.dateAnalyse, 'dd-MM-yyyy');
        const num = document.demandeAnalyse.reference;
        const center = document.demandeAnalyse.centre.name;
        const produit = document.demandeAnalyse.product.name;
        let qte = 0;
        const echantillonTotal = document.echantillonGlobal_R;
        const echantillonReduit = document.echantillonReduit_R2;
        const echantillonPropre = document.blEchPropore;
        const demande = document.demandeAnalyse.reference;
        const agriculteur = document.demandeAnalyse.farmer.firstName + ' ' + document.demandeAnalyse.farmer.lastName;
        const CIN = document.demandeAnalyse.farmer.cin;
        const coefficient_C = document.coefficient_C;

        for (let i = 0; i < document.demandeAnalyse.bonReceptionList.length; i++) {
          qte += document.demandeAnalyse.bonReceptionList[i].quantity;
        }

        const bleTendre1 = document.bleTendre1;
        const bleTendre9 = document.bleTendre9;
        const bleTendre2 = document.bleTendre2;
        const taux2 = Number((bleTendre2 / echantillonPropre).toFixed(3));
        const bleTendre3 = document.bleTendre3;
        const taux3 = bleTendre3 * coefficient_C;
        const grosseImpuretes = document.mesureGrosseImpuretes;
        const tauxgrosseImpuretes = document.tauxGrosseImpuretes;
        const bleTendre10 = document.bleTendre10;
        const taux10 = Number((bleTendre10 * document.coefficient_C).toFixed(3));
        const bleTendre11 = document.bleTendre11;
        const taux11 = Number((bleTendre11 * document.coefficient_C).toFixed(3));
        const bleTendre12 = document.bleTendre12;
        const taux12 = Number((bleTendre12 * coefficient_C).toFixed(3));
        const bleTendre13 = document.bleTendre13;
        const taux13 = Number((bleTendre13 * coefficient_C).toFixed(3));
        const bleTendre14 = document.bleTendre14;
        const taux14 = Number((bleTendre14 * coefficient_C).toFixed(3));
        const bleTendre15 = document.bleTendre15;
        const taux15 = Number((bleTendre15 * coefficient_C).toFixed(3));
        const bleTendre16 = document.bleTendre16;
        const taux16 = Number((bleTendre16 * coefficient_C).toFixed(3));
        const bleTendre17 = document.bleTendre17;
        const taux17 = Number((bleTendre17 * coefficient_C).toFixed(3));
        const bleTendre30 = document.bleTendre30;
        const taux30 = Number((bleTendre30 * coefficient_C).toFixed(3));
        const bleTendre31 = document.bleTendre31;
        const taux31 = Number((bleTendre31 * coefficient_C).toFixed(3));
        const bleTendre32 = document.bleTendre32;
        const taux32 = Number((bleTendre32 * coefficient_C).toFixed(3));
        const bleTendre33 = document.bleTendre33;
        const taux33 = Number((bleTendre33 * coefficient_C).toFixed(3));
        const bleTendre34 = document.bleTendre34;
        const taux34 = Number((bleTendre34 * coefficient_C).toFixed(3));
        const bleTendre35 = document.bleTendre35;
        const taux35 = Number((bleTendre35 * coefficient_C).toFixed(3));
        const bleTendre36 = document.bleTendre36;
        const taux36 = Number((bleTendre36 * coefficient_C).toFixed(3));
        const bleTendre26 = document.bleTendreBalle;
        const taux26 = Number((bleTendre26 * coefficient_C).toFixed(3));
        const bleTendre37 = document.bleTendre37;
        const taux37 = Number((bleTendre37 * coefficient_C).toFixed(3));
        const bleTendre38 = document.bleTendre38;
        const taux38 = Number((bleTendre38 * coefficient_C).toFixed(3));
        const bleTendre39 = document.bleTendre39;
        const taux39 = Number((bleTendre39 * coefficient_C).toFixed(3));
        const bleTendre40 = document.bleTendre40;
        const taux40 = Number((bleTendre40 * coefficient_C).toFixed(3));
        const bleTendre41 = document.bleTendre41;
        const taux41 = Number((bleTendre41 * coefficient_C).toFixed(3));;
        const bleTendre42 = document.bleTendre42;
        const taux42 = Number((bleTendre42 * coefficient_C).toFixed(3));
        const bleTendre20 = document.impurtesTotal;
        const taux20 = Number((bleTendre20 * coefficient_C).toFixed(3));

        const totalBonif = Number(document.bulletinAnalyse.totalBonification.toFixed(3));
        const totalRefact = Number(document.bulletinAnalyse.totalRefaction.toFixed(3));
        const bilanAnalyse = Number((totalBonif - totalRefact).toFixed(3));
        const prixBase = document.demandeAnalyse.product.startingPrice;
        const prixUnitaire = document.bulletinAnalyse.prixUnitaire;
        const bonif9 = document.bulletinAnalyse.bleTendre9;
        const refact1 = document.bulletinAnalyse.bleTendre1;
        const refact2 = document.bulletinAnalyse.bleTendre2;
        const refact3 = document.bulletinAnalyse.bleTendre3;
        const refact10 = document.bulletinAnalyse.bleTendre10;
        const refact11 = document.bulletinAnalyse.bleTendre11;
        const refact12 = document.bulletinAnalyse.bleTendre12;
        const refact13 = document.bulletinAnalyse.bleTendre13;
        const refact14 = document.bulletinAnalyse.bleTendre14;
        const refact15 = document.bulletinAnalyse.bleTendre15;
        const refact16 = document.bulletinAnalyse.bleTendre16;
        const refact17 = document.bulletinAnalyse.bleTendre17;

        const refact26 = document.bulletinAnalyse.bleTendreBalle;
        const refact30 = document.bulletinAnalyse.bleTendre30;
        const refact31 = document.bulletinAnalyse.bleTendre31;
        const refact32 = document.bulletinAnalyse.bleTendre32;
        const refact33 = document.bulletinAnalyse.bleTendre33;
        const refact34 = document.bulletinAnalyse.bleTendre34;
        const refact35 = document.bulletinAnalyse.bleTendre35;
        const refact36 = document.bulletinAnalyse.bleTendre36;
        const refact37 = document.bulletinAnalyse.bleTendre37;
        const refact38 = document.bulletinAnalyse.bleTendre38;
        const refact39 = document.bulletinAnalyse.bleTendre39;
        const refact40 = document.bulletinAnalyse.bleTendre40;
        const refact41 = document.bulletinAnalyse.bleTendre41;
        const refact42 = document.bulletinAnalyse.bleTendre42;
        const tauxdeBonif = totalBonif;
        const tauxdeRefact = totalRefact;

       const critereValues = [];
        critereValues.push(
          [1, 'Poids Spécifique PS', 'Refaction', 'Oui', bleTendre1, bleTendre1, refact1],
          [9, 'Humidité', 'Bonification', 'Oui', bleTendre9, bleTendre9, bonif9],
          [2, 'Grains Cassés', 'Refcation', 'Oui', bleTendre2, taux2, refact2],
          [3, 'Grains germées', 'Refcation', 'Oui', bleTendre3, taux3, refact3],
          [5, 'Grosses Impurétés', 'Refcation', 'Oui', grosseImpuretes, tauxgrosseImpuretes, '--'],
          [10, 'Total Impr grains', 'Refcation', 'Oui', bleTendre10, taux10, refact10],
          [11, 'Grains chauffées ', 'Refcation', 'Oui', bleTendre11, taux11, refact11],
          [12, 'Grains céreales ', 'Refcation', 'Oui', bleTendre12, taux12, refact12],
          [13, 'Graines echaudés ', 'Refcation', 'Oui', bleTendre13, taux13, refact13],
          [14, 'coloration des germes ', 'Refcation', 'Oui', bleTendre14, taux14, refact14],
          [15, ' Graines punaisées ', 'Refcation', 'Oui', bleTendre15, taux15, refact15],
          [16, ' Graines attaquées ', 'Refcation', 'Oui', bleTendre16, taux16, refact16],
          [17, ' Autres fusariés ', 'Refcation', 'Oui', bleTendre17, taux17, refact17],
          [30, 'Total Impr divers ', 'Refcation', 'Oui', bleTendre30, taux30, refact30],
          [31, 'Ail ', 'Refcation', 'Oui', bleTendre31, taux31, refact31],
          [32, 'Funegrec ', 'Refcation', 'Oui', bleTendre32, taux32, refact32],
          [33, 'Ivraie ', 'Refcation', 'Oui', bleTendre33, taux33, refact33],
          [34, 'Mellilot ', 'Refcation', 'Oui', bleTendre34, taux34, refact34],
          [35, 'Graines brulées ', 'Refcation', 'Oui', bleTendre35, taux35, refact35],
          [36, 'Ergot ', 'Refcation', 'Oui', bleTendre36, taux36, refact36],
          [37, 'Graines avariées ', 'Refcation', 'Oui', bleTendre37, taux37, refact37],
          [42, 'Autres impuretés', 'Refcation', 'Oui', bleTendre42, taux42, refact42],
          [38, 'Graines cariées ', 'Refcation', 'Oui', bleTendre38, taux38, refact38],
          [39, 'Impuretés propres ', 'Refcation', 'Oui', bleTendre39, taux39, refact39],
          [40, 'Insectes mortes ', 'Refcation', 'Oui', bleTendre40, taux40, refact40],
          [41, 'Graines etrangéres ', 'Refcation', 'Oui', bleTendre41, taux41, refact41],
          [26, 'Balle', 'Refcation', 'Oui', bleTendre26, taux26, refact26],
          [20, 'Impuretés totales ', 'Refcation', 'Oui', bleTendre20, taux20, '--'],
        );

        critereValues.forEach(e => {
            if (e[4] != null && e[4] !== 0) {
              docDefinition.content[4].table.body.push(
                [{'text': e[0], 'style': 'tableContent'}, {'text': e[1], 'style': 'tableContent'},
                  {'text': e[2], 'style': 'tableContent'}, {'text': e[3], 'style': 'tableContent'},
                  {'text': e[4], 'style': 'tableContent'}, {'text': e[5], 'style': 'tableContent'},
                  {'text': e[6]}]
              );
            }
          }

        );


        let optionStr = JSON.stringify(docDefinition);
        optionStr = this.unsafeRedactName(optionStr, 'dateAnalyse' , dateAnalyse);
        optionStr = this.unsafeRedactName(optionStr, 'num' , num);
        optionStr = this.unsafeRedactName(optionStr, 'center' , center);
        optionStr = this.unsafeRedactName(optionStr, 'produit' , produit);
        optionStr = this.unsafeRedactName(optionStr, 'demande' , demande);
        optionStr = this.unsafeRedactName(optionStr, 'qte' , qte);
        optionStr = this.unsafeRedactName(optionStr, 'agriculteur' , agriculteur);
        optionStr = this.unsafeRedactName(optionStr, 'CIN' , CIN);
        optionStr = this.unsafeRedactName(optionStr, 'echantillonTotal' , echantillonTotal);
        optionStr = this.unsafeRedactName(optionStr, 'echantillonReduit' , echantillonReduit);
        optionStr = this.unsafeRedactName(optionStr, 'echantillonPropre' , echantillonPropre);
        optionStr = this.unsafeRedactName(optionStr, 'bordereau' , document.borderreauAnalyseNum ? document.borderreauAnalyseNum : '');
        optionStr = this.unsafeRedactName(optionStr, 'echantillonReduit1' , document.echantillonReduit_R1 ? document.echantillonReduit_R1 : '');

        optionStr = this.unsafeRedactName(optionStr, 'totalBonif' , totalBonif);
        optionStr = this.unsafeRedactName(optionStr, 'totalRefact' , totalRefact);
        optionStr = this.unsafeRedactName(optionStr, 'tauxdeRefact' , tauxdeRefact);
        optionStr = this.unsafeRedactName(optionStr, 'tauxdeBonif' , tauxdeBonif);
        optionStr = this.unsafeRedactName(optionStr, 'bilanAnalyse' , bilanAnalyse);
        optionStr = this.unsafeRedactName(optionStr, 'prixBase' , prixBase);
        optionStr = this.unsafeRedactName(optionStr, 'prixUnitaire' , prixUnitaire);

        docDefinition = JSON.parse(optionStr);

        if (print) {
          pdfMake.createPdf(docDefinition).print();
        } else {
          if (base64) {
            const pdfDocGenerator = pdfMake.createPdf(docDefinition);
            pdfDocGenerator.getDataUrl((dataUrl) => {
              //$('#pdf').attr('data', dataUrl );
              //this.listPDFArr.push(dataUrl);
              this.listPDFArr.push(docDefinition);
            });
          } else {
            pdfMake.createPdf(docDefinition).download(documentType + document.demandeAnalyse.reference + '.pdf');
          }
        }
      }, err => {
        // this.toastr.error(`Une erreur s'est produite lors de l'enregistrement` + ': ' + err,  `Erreur`);
      });
  }
  exportBulletinAnalyseOrgeLocal(documentType: string, document, print = false, base64 = false) {
    let jsonFile = 'bulletinAnalyseOrgeLocal.json';
    if (documentType === 'bulletinAnalyseOrgeLocal') {
      jsonFile = 'bulletinAnalyseOrgeLocal.json';  // to fix
    }


    this.loadConfig(jsonFile)
      .subscribe(docDefinition => {

        // docDefinition.header.columns[1].text = 'La Graine des Graines Tunisienne GGT';

        const dateAnalyse = this.datePipe.transform(document.dateAnalyse, 'dd-MM-yyyy');
        const num = document.demandeAnalyse.reference;
        const center = document.demandeAnalyse.centre.name;
        const produit = document.demandeAnalyse.product.name;

        const echantillonTotal = document.echantillonGlobal_R;
        const echantillonReduit = document.echantillonReduit_R2;
        const echantillonPropre = document.blEchPropore;
        const demande = document.demandeAnalyse.reference;
        const agriculteur = document.demandeAnalyse.farmer.firstName + ' ' + document.demandeAnalyse.farmer.lastName;
        const CIN = document.demandeAnalyse.farmer.cin;
        let qte = 0;
        for (let i = 0; i < document.demandeAnalyse.bonReceptionList.length; i++) {
          qte += document.demandeAnalyse.bonReceptionList[i].quantity;
        }
        const orgeLocal21 = document.orgeLocal92;
        const orgeLocal23 = document.orgeLocal93;
        const orgeLocal26 = document.orgeLocal95;
        const orgeLocal24 = document.orgeLocal94;
        const orgeLocal25 = document.orgeAttaque; const taux25 = orgeLocal25;
        const orgeLocal28 = document.impurtesTotal ? Number(document.impurtesTotal).toFixed(2) : '';

        const taux24 = Number(((orgeLocal24 / document.echantillonReduit_R2) * 100).toFixed(2));

        const taux26 = Number(((orgeLocal26 / document.echantillonReduit_R1) * 100).toFixed(2)) ;
        const taux23 = taux26;
        const totalBonif = Number(document.bulletinAnalyse.totalBonification.toFixed(2));
        const totalRefact = Number(document.bulletinAnalyse.totalRefaction.toFixed(2));
        const bilanAnalyse = Number((totalBonif - totalRefact).toFixed(2));
        const prixBase = document.demandeAnalyse.product.startingPrice;
        const prixUnitaire = document.bulletinAnalyse.prixUnitaire;
        const bonif21 = document.bulletinAnalyse.orgeLocal92;
        const refact23 = document.bulletinAnalyse.orgeLocal93;


        let optionStr = JSON.stringify(docDefinition);
        optionStr = this.unsafeRedactName(optionStr, 'dateAnalyse' , dateAnalyse);
        optionStr = this.unsafeRedactName(optionStr, 'num' , num);
        optionStr = this.unsafeRedactName(optionStr, 'center' , center);
        optionStr = this.unsafeRedactName(optionStr, 'produit' , produit);
        optionStr = this.unsafeRedactName(optionStr, 'demande' , demande);
        optionStr = this.unsafeRedactName(optionStr, 'qte' , qte ? qte.toFixed(2) : 0);
        optionStr = this.unsafeRedactName(optionStr, 'agriculteur' , agriculteur);
        optionStr = this.unsafeRedactName(optionStr, 'CIN' , CIN);
        optionStr = this.unsafeRedactName(optionStr, 'echantillonTotal' , echantillonTotal);
        optionStr = this.unsafeRedactName(optionStr, 'echantillonReduit' , echantillonReduit);
        optionStr = this.unsafeRedactName(optionStr, 'echantillonPropre' , echantillonPropre);
        optionStr = this.unsafeRedactName(optionStr, 'orgeLocal21' , orgeLocal21);
        optionStr = this.unsafeRedactName(optionStr, 'orgeLocal23' , orgeLocal23);
        optionStr = this.unsafeRedactName(optionStr, 'orgeLocal26' , orgeLocal26);
        optionStr = this.unsafeRedactName(optionStr, 'orgeLocal24' , orgeLocal24);
        optionStr = this.unsafeRedactName(optionStr, 'orgeLocal25' , orgeLocal25); // todo to check
        optionStr = this.unsafeRedactName(optionStr, 'orgeLocal28' , orgeLocal28); // todo to check
        optionStr = this.unsafeRedactName(optionStr, 'totalBonif' , totalBonif);
        optionStr = this.unsafeRedactName(optionStr, 'taux24' , taux24);
        optionStr = this.unsafeRedactName(optionStr, 'taux26' , taux26);
        optionStr = this.unsafeRedactName(optionStr, 'taux23' , taux23);
        optionStr = this.unsafeRedactName(optionStr, 'taux25' , taux25);
        optionStr = this.unsafeRedactName(optionStr, 'totalRefact' , totalRefact);
        optionStr = this.unsafeRedactName(optionStr, 'bilanAnalyse' , bilanAnalyse);
        optionStr = this.unsafeRedactName(optionStr, 'prixBase' , prixBase);
        optionStr = this.unsafeRedactName(optionStr, 'prixUnitaire' , prixUnitaire);
        optionStr = this.unsafeRedactName(optionStr, 'bonif21' , totalBonif);
        optionStr = this.unsafeRedactName(optionStr, 'refact23' , refact23);
        optionStr = this.unsafeRedactName(optionStr, 'bordereau' , document.borderreauAnalyseNum ? document.borderreauAnalyseNum : '');

        docDefinition = JSON.parse(optionStr);

        if (print) {
          pdfMake.createPdf(docDefinition).print();
        } else {
          if (base64) {
              const pdfDocGenerator = pdfMake.createPdf(docDefinition);
              pdfDocGenerator.getDataUrl((dataUrl) => {
              //$('#pdf').attr('data', dataUrl );
              //this.listPDFArr.push(dataUrl);
              this.listPDFArr.push(docDefinition);
            });
          } else {
            pdfMake.createPdf(docDefinition).download(documentType + '.pdf');
          }
        }
      }, err => {
        // this.toastr.error(`Une erreur s'est produite lors de l'enregistrement` + ': ' + err,  `Erreur`);
      });
  }
  exportBulletinAnalyseTriticale(documentType: string, document, print = false, base64 = false) {
    let jsonFile = 'bulletinAnalyseTriticale.json';
    if (documentType === 'bulletinAnalyseTriticale') {
      jsonFile = 'bulletinAnalyseTriticale.json';  // to fix
    }


    this.loadConfig(jsonFile)
      .subscribe(docDefinition => {

        // docDefinition.header.columns[1].text = 'La Graine des Graines Tunisienne GGT';

        const dateAnalyse = this.datePipe.transform(document.dateAnalyse, 'dd-MM-yyyy');
        const num = document.demandeAnalyse.reference;
        const center = document.demandeAnalyse.centre.name;
        const produit = document.demandeAnalyse.product.name;

        const echantillonReduit = document.echantillonGlobal_R;

        const demande = document.demandeAnalyse.reference;
        const agriculteur = document.demandeAnalyse.farmer.firstName + ' ' + document.demandeAnalyse.farmer.lastName;
        const CIN = document.demandeAnalyse.farmer.cin;
        let qte = 0;
        for (let i = 0; i < document.demandeAnalyse.bonReceptionList.length; i++) {
          qte += document.demandeAnalyse.bonReceptionList[i].quantity;
        }
        const triticale45 = document.triticale45;
        const triticale46 = document.triticale46;
        const triticale47 = document.triticale47;
        const triticale48 = document.triticale48;
        const taux45 = Number(((triticale45 / echantillonReduit) * 100).toFixed(2));
        const taux46 = Number(((triticale46 / echantillonReduit) * 100).toFixed(2));
        const taux47 = Number(((triticale47 / echantillonReduit) * 100).toFixed(2));
        const taux48 = Number(((triticale48 / echantillonReduit) * 100).toFixed(2));
        const totalBonif = Number(document.bulletinAnalyse.totalBonification.toFixed(2));
        const totalRefact = Number(document.bulletinAnalyse.totalRefaction.toFixed(2));
        const bilanAnalyse = Number((totalBonif - totalRefact).toFixed(2));
        const prixBase = document.demandeAnalyse.product.startingPrice;
        const prixUnitaire = document.bulletinAnalyse.prixUnitaire;
        const refact45 = document.bulletinAnalyse.triticale45;
        const refact46 = document.bulletinAnalyse.triticale46;
        const refact47 = document.bulletinAnalyse.triticale47;
        const refact48 = document.bulletinAnalyse.triticale48;



        let optionStr = JSON.stringify(docDefinition);
        optionStr = this.unsafeRedactName(optionStr, 'dateAnalyse' , dateAnalyse);
        optionStr = this.unsafeRedactName(optionStr, 'num' , num);
        optionStr = this.unsafeRedactName(optionStr, 'center' , center);
        optionStr = this.unsafeRedactName(optionStr, 'produit' , produit);
        optionStr = this.unsafeRedactName(optionStr, 'demande' , demande);
        optionStr = this.unsafeRedactName(optionStr, 'qte' , qte ? qte.toFixed(2) : 0);
        optionStr = this.unsafeRedactName(optionStr, 'agriculteur' , agriculteur);
        optionStr = this.unsafeRedactName(optionStr, 'CIN' , CIN);
        optionStr = this.unsafeRedactName(optionStr, 'echantillonReduit' , echantillonReduit);
        optionStr = this.unsafeRedactName(optionStr, 'triticale45' , triticale45);
        optionStr = this.unsafeRedactName(optionStr, 'triticale46' , triticale46);
        optionStr = this.unsafeRedactName(optionStr, 'triticale47' , triticale47);
        optionStr = this.unsafeRedactName(optionStr, 'triticale48' , triticale48);
        optionStr = this.unsafeRedactName(optionStr, 'totalBonif' , totalBonif);
        optionStr = this.unsafeRedactName(optionStr, 'taux45' , taux45);
        optionStr = this.unsafeRedactName(optionStr, 'taux46' , taux46);
        optionStr = this.unsafeRedactName(optionStr, 'taux47' , taux47);
        optionStr = this.unsafeRedactName(optionStr, 'taux48' , taux48);
        optionStr = this.unsafeRedactName(optionStr, 'totalRefact' , totalRefact);
        optionStr = this.unsafeRedactName(optionStr, 'bilanAnalyse' , bilanAnalyse);
        optionStr = this.unsafeRedactName(optionStr, 'prixBase' , prixBase);
        optionStr = this.unsafeRedactName(optionStr, 'prixUnitaire' , prixUnitaire);
        optionStr = this.unsafeRedactName(optionStr, 'refact45' , refact45);
        optionStr = this.unsafeRedactName(optionStr, 'refact46' , refact46);
        optionStr = this.unsafeRedactName(optionStr, 'refact47' , refact47);
        optionStr = this.unsafeRedactName(optionStr, 'refact48' , refact48);

        docDefinition = JSON.parse(optionStr);

        if (print) {
          pdfMake.createPdf(docDefinition).print();
        } else {
          if (base64) {
            const pdfDocGenerator = pdfMake.createPdf(docDefinition);
            pdfDocGenerator.getDataUrl((dataUrl) => {
              //$('#pdf').attr('data', dataUrl );
               //this.listPDFArr.push(dataUrl);
this.listPDFArr.push(docDefinition);
            });
          } else {
            pdfMake.createPdf(docDefinition).download(documentType + '.pdf');
          }
        }
      }, err => {
        // this.toastr.error(`Une erreur s'est produite lors de l'enregistrement` + ': ' + err,  `Erreur`);
      });
  }


  exportBon(documentType: string, document, print = false, base64 = false) {
   let jsonFile = 'bonReception.json';
    if (documentType === 'BonReception') {
      jsonFile = 'bonReception.json';  // to fix
    }
    this.loadConfig(jsonFile)
      .subscribe(docDefinition => {


        const receptionDate = this.datePipe.transform(document.receptionDate, 'dd-MM-yyyy');
        const receptionReference = document.receptionReference;
        const centre = document.centre.code + ' ' + document.centre.name;
        const gov = document.centre.gouvernorat;
        const product = document.product.name;
        const farmerCode = document.farmer.cin;
        const farmerName = document.farmer.firstName + ' ' + document.farmer.lastName;
        const ticket = document.ticketPesage;
        const quantity = document.quantity ? document.quantity.toFixed(2) : 0.00 ;
        const analyseIsRequired = document.analyseIsRequired;
        const previwedresultDate = this.datePipe.transform(document.previwedresultDate, 'dd-MM-yyyy') ;
        const sampleIstaken = document.sampleIstaken;
        let optionStr = JSON.stringify(docDefinition);
        optionStr = this.unsafeRedactName(optionStr, 'receptionDate' , receptionDate);
        optionStr = this.unsafeRedactName(optionStr, 'matriculeFiscale' , '1817344TPM000');
        optionStr = this.unsafeRedactName(optionStr, 'num' , receptionReference);
        optionStr = this.unsafeRedactName(optionStr, 'centre' , centre);
        optionStr = this.unsafeRedactName(optionStr, 'product' , product);
        optionStr = this.unsafeRedactName(optionStr, 'farmerCode' , farmerCode);
        optionStr = this.unsafeRedactName(optionStr, 'farmer' , farmerName);
        optionStr = this.unsafeRedactName(optionStr, 'gov' , gov);
        optionStr = this.unsafeRedactName(optionStr, 'ticket' , ticket);
        optionStr = this.unsafeRedactName(optionStr, 'quantity' , quantity);
        optionStr = this.unsafeRedactName(optionStr, 'analyseIsRequired' , analyseIsRequired);
        // tslint:disable-next-line:triple-equals
        if (previwedresultDate && previwedresultDate != 'null') {
          optionStr = this.unsafeRedactName(optionStr, 'previwedresultDate' , previwedresultDate);
        } else {
          optionStr = this.unsafeRedactName(optionStr, 'previwedresultDate' , '');
        }
        optionStr = this.unsafeRedactName(optionStr, 'sampleIstaken' , sampleIstaken);
        console.log(optionStr);
        docDefinition = JSON.parse(optionStr);

        if (document.sampleIstaken) {
          docDefinition.content[4].table.body[1][0].text = 'Oui';
        } else {
          docDefinition.content[4].table.body[1][0].text = 'Non';
        }

        if (document.analyseIsRequired) {
          docDefinition.content[4].table.body[1][2].text = 'Oui';
        } else {
          docDefinition.content[4].table.body[1][2].text = 'Non';
        }

        if (print) {
          pdfMake.createPdf(docDefinition).print();
        } else {
          if (base64) {
            const pdfDocGenerator = pdfMake.createPdf(docDefinition);
            pdfDocGenerator.getDataUrl((dataUrl) => {
              //$('#pdf').attr('data', dataUrl );
               //this.listPDFArr.push(dataUrl);
this.listPDFArr.push(docDefinition);
            });
          } else {
            pdfMake.createPdf(docDefinition).download(documentType + '_' + document.receptionReference + '.pdf');
          }
        }
      }, err => {
        // this.toastr.error(`Une erreur s'est produite lors de l'enregistrement` + ': ' + err,  `Erreur`);
      });
  }
  exportBulletinPaie(documentType: string, document, print = false, base64 = false) {
   let jsonFile = 'bulletinPaie.json';
    if (documentType === 'BulletinPaie') {
      jsonFile = 'bulletinPaie.json';  // to fix
    }
    this.loadConfig(jsonFile)
      .subscribe(docDefinition => {

        let receptionDate = this.datePipe.transform(document.dateBP, 'dd-MM-yyyy');
        receptionDate = receptionDate ? receptionDate : '      ';

        const receptionReference = document.demandeAnalyse.reference;
        const centre = document.demandeAnalyse.centre.code;
        const centreName = document.demandeAnalyse.centre.name;
        const bordereau = document.bordereauPaieNum ? document.bordereauPaieNum : '';
        const product = document.demandeAnalyse.product.name;
        const productCode = document.demandeAnalyse.product.code;
        const farmerCode = document.demandeAnalyse.farmer.cin;
        const farmerName = document.demandeAnalyse.farmer.firstName + ' ' + document.demandeAnalyse.farmer.lastName;


        let quantity = document.quantity;
        quantity = quantity ? quantity.toFixed(2) : Number(0).toFixed(2);

        const taxeSolidarity = Number(((document.demandeAnalyse.product.taxeSolidarity) * quantity)).toFixed(3);
        const taxeStatistique = Number(((document.demandeAnalyse.product.taxeStatistique) * quantity)).toFixed(3) ;

        let startingPrice = document.basePrice;
        startingPrice = startingPrice ? startingPrice.toFixed(3) : Number(0).toFixed(3);

        let prime = document.prime;
        prime = prime ? prime.toFixed(3) : Number(0).toFixed(3);

        let bonifications = document.bonifications;
        bonifications = bonifications ? bonifications.toFixed(3) : Number(0).toFixed(3);

        let refactions = document.refactions;
        refactions = refactions ? refactions.toFixed(3) : Number(0).toFixed(3);

        let retenueCredit = document.retenueCredit;
        retenueCredit = retenueCredit ? retenueCredit.toFixed(3) : Number(0).toFixed(3);
        let autreRetenue = document.autreRetenue;
        autreRetenue = autreRetenue ? autreRetenue.toFixed(3) : Number(0).toFixed(3);

        let buyingPrice = document.buyingPrice;
        buyingPrice = buyingPrice ? buyingPrice.toFixed(3) : Number(0).toFixed(3);

        let totalPrice = document.totalPrice;
        totalPrice = totalPrice ? totalPrice.toFixed(3) : Number(0).toFixed(3);

        let netPrice = document.netPrice;
        netPrice = netPrice ? netPrice.toFixed(3) : Number(0).toFixed(3);

        const currencyUnit = {
          'locale': 'fr',
          'majorUnit': 'dinar',
          'majorUnitPlural': 'dinars',
          'minorUnit': 'millime',
          'minorUnitPlural': 'millimes',
          'partsSeparator': 'et',
          'comma': ',',
          'defaultUnit': true
        };
        let totalNetAPayerStr;
        totalNetAPayerStr = this.decimalPipe.transform(document.netPrice, '1.3-3');
        totalNetAPayerStr = totalNetAPayerStr.replace(',', '');
        totalNetAPayerStr = totalNetAPayerStr.replace(/[\s]/, '');
        // const buyingPrice = document.demandeAnalyse.product.buyingPrice;
        // const priceToLetter = document.netPriceAsText;
        const priceToLetter = this.converterUtils.spiWrittenNumber(totalNetAPayerStr,
          currencyUnit.majorUnitPlural,
          currencyUnit.minorUnitPlural,
          currencyUnit.locale,
          currencyUnit.partsSeparator,
          currencyUnit.comma);
        const cheque = document.cheque ? document.cheque : '';
        const bank = document.bank ? document.bank : '';
        const year = this.datePipe.transform(document.dateBP, 'yyyy');

        let modePayment = document.modePayment ? document.modePayment : '';
        if ( document.modePayment === 'virement') {
          modePayment = 'virement';
        }
        if ( document.modePayment === 'Autre') {
          modePayment = 'cheque';
        }



        let optionStr = JSON.stringify(docDefinition);

        optionStr = this.unsafeRedactName(optionStr, 'receptionDate' , receptionDate);
        optionStr = this.unsafeRedactName(optionStr, 'num' , receptionReference);
        optionStr = this.unsafeRedactName(optionStr, 'centre' , centre);
        optionStr = this.unsafeRedactName(optionStr, 'centreName' , centreName);
        optionStr = this.unsafeRedactName(optionStr, 'product' , product);
        optionStr = this.unsafeRedactName(optionStr, 'productCode' , productCode);
        optionStr = this.unsafeRedactName(optionStr, 'startingPrice' , startingPrice);
        optionStr = this.unsafeRedactName(optionStr, 'taxeStatistique' , taxeStatistique);
        optionStr = this.unsafeRedactName(optionStr, 'taxeSolidarite' , taxeSolidarity);
        optionStr = this.unsafeRedactName(optionStr, 'farmerCode' , farmerCode);
        optionStr = this.unsafeRedactName(optionStr, 'farmerName' , farmerName);
        optionStr = this.unsafeRedactName(optionStr, 'bordereau' , bordereau);
        optionStr = this.unsafeRedactName(optionStr, 'quantity' , quantity);
        optionStr = this.unsafeRedactName(optionStr, 'bonifications' , bonifications);
        optionStr = this.unsafeRedactName(optionStr, 'refactions' , refactions);
        optionStr = this.unsafeRedactName(optionStr, 'totalPrice' , totalPrice);
        optionStr = this.unsafeRedactName(optionStr, 'retenueCredit' , retenueCredit);
        optionStr = this.unsafeRedactName(optionStr, 'autreRetenue' , autreRetenue);
        optionStr = this.unsafeRedactName(optionStr, 'prime' , prime);
        optionStr = this.unsafeRedactName(optionStr, 'buyingPrice' , buyingPrice);
        optionStr = this.unsafeRedactName(optionStr, 'netPrice' , netPrice);
        optionStr = this.unsafeRedactName(optionStr, 'priceToLetter' , priceToLetter);
        optionStr = this.unsafeRedactName(optionStr, 'cheque' , cheque);
        optionStr = this.unsafeRedactName(optionStr, 'modePayment' , modePayment);
        optionStr = this.unsafeRedactName(optionStr, 'bank' , bank);
        optionStr = this.unsafeRedactName(optionStr, 'year' , year);

        console.log(optionStr);
        docDefinition = JSON.parse(optionStr);

        if (print) {
          pdfMake.createPdf(docDefinition).print();
        } else {
          if (base64) {
            const pdfDocGenerator = pdfMake.createPdf(docDefinition);
            pdfDocGenerator.getDataUrl((dataUrl) => {
              //$('#pdf').attr('data', dataUrl );
              //this.listPDFArr.push(dataUrl);
              this.listPDFArr.push(docDefinition);
            });
          } else {
            pdfMake.createPdf(docDefinition).download(documentType + '_' + document.demandeAnalyse.reference + '.pdf');
          }
        }
      }, err => {
        // this.toastr.error(`Une erreur s'est produite lors de l'enregistrement` + ': ' + err,  `Erreur`);
      });
  }

  exportDemandeAnalyse(documentType: string, document, print = false, base64 = false) {
   let jsonFile = 'demandeAnalyse.json';
    if (documentType === 'DemandeAnalyse') {
      jsonFile = 'demandeAnalyse.json';  // to fix
    }
    this.loadConfig(jsonFile)
      .subscribe(docDefinition => {
        let optionStr = JSON.stringify(docDefinition);
        const receptionDate = this.datePipe.transform(document.demandeDate, 'dd-MM-yyyy');
        const receptionReference = document.reference;
        const centre = document.centre.code + ' ' + document.centre.name;
        const gov = document.centre.gouvernorat;
        const product = document.product.name;
        const farmerCode = document.farmer.cin;
        const farmerName = document.farmer.firstName + ' ' + document.farmer.lastName;
        const reference = '';
        let quantity = '0';

        let qte = 0;
        for (let i = 0; i < document.bonReceptionList.length; i++) {
          qte += document.bonReceptionList[i].quantity;
        }

        if (qte && qte > 0) {
          quantity = Number(qte).toFixed(2);
        }

        optionStr = this.unsafeRedactName(optionStr, 'receptionDate' , receptionDate);
        optionStr = this.unsafeRedactName(optionStr, 'matriculeFiscale' , '1817344TPM000');
        optionStr = this.unsafeRedactName(optionStr, 'num' , receptionReference);
        optionStr = this.unsafeRedactName(optionStr, 'centre' , centre);
        optionStr = this.unsafeRedactName(optionStr, 'product' , product);
        optionStr = this.unsafeRedactName(optionStr, 'farmerCode' , farmerCode);
        optionStr = this.unsafeRedactName(optionStr, 'farmer' , farmerName);
        optionStr = this.unsafeRedactName(optionStr, 'reference' , reference);
        optionStr = this.unsafeRedactName(optionStr, 'gov' , gov);
        optionStr = this.unsafeRedactName(optionStr, 'qte' , quantity);

        if (document.echantillonRecu) {
          optionStr = this.unsafeRedactName(optionStr, 'echantillonRecu' , 'Oui');
        } else {
          optionStr = this.unsafeRedactName(optionStr, 'echantillonRecu' , 'Non');
        }

        // optionStr = this.unsafeRedactName(optionStr, 'quantité' , quantité);
        // console.log(optionStr);
        docDefinition = JSON.parse(optionStr);

        for (let i = 0; i < document.bonReceptionList.length; i++) {

          const qte = Number(document.bonReceptionList[i].quantity).toFixed(2);
          const row = [
            {
              'text': document.bonReceptionList[i].receptionDate,
              'style': 'tableContent',
              'border': [true, true, true, true]

            }, {
              'text': document.bonReceptionList[i].receptionReference,
              'style': 'tableContent',
              'border': [true, true, true, true]

            }, {
              'text': product,
              'style': 'tableContent',
              'border': [true, true, true, true]

            },{
              'text': qte,
              'style': 'tableContent',
              'border': [true, true, true, true]

            }];
          docDefinition.content[4].table.body.push(row);
        }

        docDefinition.content[4].table.body.push([
          {
            'text': 'Quantité Total (QL) :',
            'alignment' : 'right',
            'bold': true,
            'style': 'tableContent',
            'colSpan': 3,
            'border': [true, true, true, true]
          }, {}, {}, {
            'text': qte ? qte.toFixed(2) : 0,
            'bold': true,
            'style': 'tableContent',
            'border': [true, true, true, true]
          }]);

        if (print) {
          pdfMake.createPdf(docDefinition).print();
        } else {
          if (base64) {
            const pdfDocGenerator = pdfMake.createPdf(docDefinition);
            pdfDocGenerator.getDataUrl((dataUrl) => {
              //$('#pdf').attr('data', dataUrl );
               //this.listPDFArr.push(dataUrl);
this.listPDFArr.push(docDefinition);
            });
          } else {
            pdfMake.createPdf(docDefinition).download(documentType + '_' + document.reference + '.pdf');
          }
        }
      }, err => {
        // this.toastr.error(`Une erreur s'est produite lors de l'enregistrement` + ': ' + err,  `Erreur`);
      });
  }

  exportBonLIvraison(documentType: string, document, print = false, base64 = false) {
    let jsonFile = 'bonLivraison.json';
    if (documentType === 'BonLivraison') {
      jsonFile = 'bonLivraison.json';  // to fix
    }
    this.loadConfig(jsonFile)
      .subscribe(docDefinition => {
        const livraisonDate = this.datePipe.transform(document.dateBL, 'dd-MM-yyyy');
        const date = this.datePipe.transform(new Date(), 'dd-MM-yyyy');
        const centre = document.bonCommande.centreLivraison.code + ' ' + document.bonCommande.centreLivraison.name;
        const product = document.bonCommande.product.name;
        const bonCommandeNum = document.bonCommande.num;
        const transporteur = document.transporteur;
        const quantityBL = document.quantityBL;
        const num = document.numBL ? document.numBL : '';
        const benefciary = document.bonCommande.beneficiary ? document.bonCommande.beneficiary : '';

        let optionStr = JSON.stringify(docDefinition);
        optionStr = this.unsafeRedactName(optionStr, 'numBL' , num);
        optionStr = this.unsafeRedactName(optionStr, 'livraisonDate' , livraisonDate);
        optionStr = this.unsafeRedactName(optionStr, 'matriculeFiscale' , '1817344TPM000');
        optionStr = this.unsafeRedactName(optionStr, 'bonCommandeNum' , bonCommandeNum);
        optionStr = this.unsafeRedactName(optionStr, 'transporteur' , transporteur);
        optionStr = this.unsafeRedactName(optionStr, 'quantityBL' , quantityBL);

        optionStr = this.unsafeRedactName(optionStr, 'centre' , centre);
        optionStr = this.unsafeRedactName(optionStr, 'product' , product);
        optionStr = this.unsafeRedactName(optionStr, 'date' , date);

        optionStr = this.unsafeRedactName(optionStr, 'benefciary' , benefciary);

        docDefinition = JSON.parse(optionStr);

        if (print) {
          pdfMake.createPdf(docDefinition).print();
        } else {
          if (base64) {
            const pdfDocGenerator = pdfMake.createPdf(docDefinition);
            pdfDocGenerator.getDataUrl((dataUrl) => {
              //$('#pdf').attr('data', dataUrl );
               //this.listPDFArr.push(dataUrl);
                this.listPDFArr.push(docDefinition);
            });
          } else {
            pdfMake.createPdf(docDefinition).download(documentType + '.pdf');
          }
        }
      }, err => {
        // this.toastr.error(`Une erreur s'est produite lors de l'enregistrement` + ': ' + err,  `Erreur`);
      });
  }


  exportBonTransfert(documentType: string, document, print = false, base64 = false) {
    let jsonFile = 'bonTransfert.json';
    if (documentType === 'BonTransfert') {
      jsonFile = 'bonTransfert.json';  // to fix
    }
    this.loadConfig(jsonFile)
      .subscribe(docDefinition => {
        const num = document.numBL ? document.numBL : '';
        const livraisonDate = this.datePipe.transform(document.dateBL, 'dd-MM-yyyy');
        const dateBL = document.dateBL;
        const date = this.datePipe.transform(new Date(), 'dd-MM-yyyy');
        const centreLivraison = document.centreLivraison ? document.centreLivraison.code + ' ' + document.centreLivraison.name : '';
        const centreReception = document.centreReception ? document.centreReception.code + ' ' + document.centreReception.name : '';
        const product = document.product.name;
        const quantityBL = document.quantityBL;
        //const transporteur = document.transporteur;

        let optionStr = JSON.stringify(docDefinition);
        optionStr = this.unsafeRedactName(optionStr, 'numBL' , num);
        optionStr = this.unsafeRedactName(optionStr, 'livraisonDate' , livraisonDate);
        optionStr = this.unsafeRedactName(optionStr, 'matriculeFiscale' , '1817344TPM000');
        optionStr = this.unsafeRedactName(optionStr, 'transporteur' , '');
        optionStr = this.unsafeRedactName(optionStr, 'quantityBL' , quantityBL);
        optionStr = this.unsafeRedactName(optionStr, 'centreLivraison' , centreLivraison);
        optionStr = this.unsafeRedactName(optionStr, 'centreReception' , centreReception);
        optionStr = this.unsafeRedactName(optionStr, 'product' , product);
        optionStr = this.unsafeRedactName(optionStr, 'date' , date);

        docDefinition = JSON.parse(optionStr);

        if (print) {
          pdfMake.createPdf(docDefinition).print();
        } else {
          if (base64) {
            const pdfDocGenerator = pdfMake.createPdf(docDefinition);
            pdfDocGenerator.getDataUrl((dataUrl) => {
              //$('#pdf').attr('data', dataUrl );
              //this.listPDFArr.push(dataUrl);
              this.listPDFArr.push(docDefinition);
            });
          } else {
            pdfMake.createPdf(docDefinition).download(documentType + '.pdf');
          }
        }
      }, err => {
        // this.toastr.error(`Une erreur s'est produite lors de l'enregistrement` + ': ' + err,  `Erreur`);
      });
  }

  exportFactureAcompte(documentType: string, document, print = false, base64 = false) {
    let jsonFile = 'factureAcompte.json';
    if (documentType === 'FactureAcompte') {
      jsonFile = 'factureAcompte.json';  // to fix
    }
    this.loadConfig(jsonFile)
      .subscribe(docDefinition => {


        const receptionDate = this.datePipe.transform(document.dateFacture, 'dd-MM-yyyy');
        const receptionReference = document.reference;
        const centre = document.bonCommande.centreLivraison.name;
        const bc = document.bonCommande.num;
        const beneficiary = document.bonCommande.beneficiary;
        const dateFacture = this.datePipe.transform(document.dateFacture, 'dd-MM-yyyy' ) ;

        const product = document.bonCommande.product.name;
        const prixBase = document.bonCommande.product.startingPrice;
        const prime = document.bonCommande && document.bonCommande.product.prime ? document.bonCommande.product.prime.toFixed(3) : Number(0).toFixed(3);
        const prixUnitaire = document.prixUnitaire ? document.prixUnitaire.toFixed(3) : Number(0).toFixed(3);
        const acompte = document.accompte ? document.accompte.toFixed(3) : Number(0).toFixed(3);

        let netAPayer = document.netAPayer;
        netAPayer = netAPayer ? netAPayer.toFixed(3) : Number(0).toFixed(3);
        console.log(netAPayer);
        let netAPayerAsText = document.netAPayerAsText;

        netAPayerAsText = this.decimalPipe.transform(document.netAPayer, '1.3-3');
        netAPayerAsText = netAPayerAsText.replace(',', '');
        netAPayerAsText = netAPayerAsText.replace(/[\s]/, '');

        netAPayerAsText = this.converterUtils.spiWrittenNumber(netAPayer,
          this.currencyUnit.majorUnitPlural,
          this.currencyUnit.minorUnitPlural,
          this.currencyUnit.locale,
          this.currencyUnit.partsSeparator,
          this.currencyUnit.comma);

        const quantity = document.quantity;

        const dateBC = this.datePipe.transform(document.bonCommande.startDate, 'dd-MM-yyyy') ;

        let optionStr = JSON.stringify(docDefinition);
        optionStr = this.unsafeRedactName(optionStr, 'matriculeFiscale' , '1817344TPM000');
        optionStr = this.unsafeRedactName(optionStr, 'receptionDate' , receptionDate);
        optionStr = this.unsafeRedactName(optionStr, 'reference' , receptionReference);
        optionStr = this.unsafeRedactName(optionStr, 'dateFacture' , dateFacture);
        optionStr = this.unsafeRedactName(optionStr, 'centre' , centre);
        optionStr = this.unsafeRedactName(optionStr, 'product' , product);
        optionStr = this.unsafeRedactName(optionStr, 'bc' , bc);
        optionStr = this.unsafeRedactName(optionStr, 'beneficiary' , beneficiary);
        optionStr = this.unsafeRedactName(optionStr, 'dateBC' , dateBC);
        optionStr = this.unsafeRedactName(optionStr, 'prixBase' , prixBase);
        optionStr = this.unsafeRedactName(optionStr, 'prime' , prime);
        optionStr = this.unsafeRedactName(optionStr, 'prixUnitaire' , prixUnitaire);
        optionStr = this.unsafeRedactName(optionStr, 'acompte' , acompte);
        optionStr = this.unsafeRedactName(optionStr, 'netAPayerAsText' , netAPayerAsText);
        optionStr = this.unsafeRedactName(optionStr, 'total' , netAPayer);

        optionStr = this.unsafeRedactName(optionStr, 'quantity' , quantity);

        docDefinition = JSON.parse(optionStr);


        if (print) {
          pdfMake.createPdf(docDefinition).print();
        } else {
          if (base64) {
            const pdfDocGenerator = pdfMake.createPdf(docDefinition);
            pdfDocGenerator.getDataUrl((dataUrl) => {
              //$('#pdf').attr('data', dataUrl );
               //this.listPDFArr.push(dataUrl);
this.listPDFArr.push(docDefinition);
            });
          } else {
            pdfMake.createPdf(docDefinition).download(documentType + '_' + document.reference + '.pdf');
          }
        }
      }, err => {
        // this.toastr.error(`Une erreur s'est produite lors de l'enregistrement` + ': ' + err,  `Erreur`);
      });
  }

  exportFactureReliquat(documentType: string, document, print = false, base64 = false) {
    let jsonFile = 'factureReliquat.json';
    if (documentType === 'FactureReliquat') {
      jsonFile = 'factureReliquat.json';  // to fix
    }

    this.loadConfig(jsonFile)
      .subscribe(docDefinition => {

        const receptionDate = this.datePipe.transform(document.dateFacture, 'dd-MM-yyyy');
        const date = this.datePipe.transform(new Date(), 'dd-MM-yyyy');
        const receptionReference = document.reference;
        const factureAcompte = document.factureAccompte.reference;
        const dateFacture = this.datePipe.transform(document.dateFacture, 'dd-MM-yyyy' ) ;
        const centre = document.factureAccompte.bonCommande.centreLivraison.name;
        const bc = document.factureAccompte.bonCommande.num;
        const product = document.factureAccompte.bonCommande.product.name;
        const prixBase = document.factureAccompte.prixUnitaire ? document.factureAccompte.prixUnitaire.toFixed(3) : Number(0).toFixed(3);
        const bonification = document.bonification ? document.bonification.toFixed(3) : Number(0).toFixed(3);
        const refaction = document.refaction ? document.refaction.toFixed(3) : Number(0).toFixed(3);
        const prixUnitaire = document.prixFinal ? document.prixFinal.toFixed(3) : Number(0).toFixed(3);
        const acompte = document.factureAccompte.accompte * 100;
        let totalNb = document.prixFinal * document.factureAccompte.quantity;
        const total = totalNb ? totalNb.toFixed(3) : Number(0).toFixed(3);
        let totalAcompte = document.factureAccompte.netAPayer;
        totalAcompte = totalAcompte ? totalAcompte.toFixed(3) : Number(0).toFixed(3);
        const beneficiary = document.factureAccompte && document.factureAccompte.bonCommande ? document.factureAccompte.bonCommande.beneficiary: '';

        let reste = document.netAPayer;
        reste = reste ? reste.toFixed(3) : Number(0).toFixed(3);

        let netAPayerAsText;
        netAPayerAsText = this.decimalPipe.transform(reste, '1.3-3');
        netAPayerAsText = netAPayerAsText.replace(',', '');
        netAPayerAsText = netAPayerAsText.replace(/[\s]/, '');

        netAPayerAsText = this.converterUtils.spiWrittenNumber(reste,
          this.currencyUnit.majorUnitPlural,
          this.currencyUnit.minorUnitPlural,
          this.currencyUnit.locale,
          this.currencyUnit.partsSeparator,
          this.currencyUnit.comma);

        const quantity = document.factureAccompte.quantity;

        const dateBC = this.datePipe.transform(document.factureAccompte.bonCommande.startDate, 'dd-MM-yyyy') ;

        let optionStr = JSON.stringify(docDefinition);
        optionStr = this.unsafeRedactName(optionStr, 'receptionDate' , receptionDate);
        optionStr = this.unsafeRedactName(optionStr, 'matriculeFiscale' , '1817344TPM000');
        optionStr = this.unsafeRedactName(optionStr, 'date' , date);
        optionStr = this.unsafeRedactName(optionStr, 'reference' , receptionReference);
        optionStr = this.unsafeRedactName(optionStr, 'centre' , centre);
        optionStr = this.unsafeRedactName(optionStr, 'dateFacture' , dateFacture);
        optionStr = this.unsafeRedactName(optionStr, 'product' , product);
        optionStr = this.unsafeRedactName(optionStr, 'bc' , bc);
        optionStr = this.unsafeRedactName(optionStr, 'dateBC' , dateBC);
        optionStr = this.unsafeRedactName(optionStr, 'prixBase' , prixBase);
        optionStr = this.unsafeRedactName(optionStr, 'bonification' , bonification);
        optionStr = this.unsafeRedactName(optionStr, 'beneficiary' , beneficiary);
        optionStr = this.unsafeRedactName(optionStr, 'refaction' , refaction);
        optionStr = this.unsafeRedactName(optionStr, 'prixUnitaire' , prixUnitaire);
        optionStr = this.unsafeRedactName(optionStr, 'acompte' , acompte);
        optionStr = this.unsafeRedactName(optionStr, 'netAPayerAsText' , netAPayerAsText);
        optionStr = this.unsafeRedactName(optionStr, 'total' , total);
        optionStr = this.unsafeRedactName(optionStr, 'factureAcompte' , factureAcompte);
        optionStr = this.unsafeRedactName(optionStr, 'quantity' , quantity);
        optionStr = this.unsafeRedactName(optionStr, 'totalAcompte' , totalAcompte);
        optionStr = this.unsafeRedactName(optionStr, 'reste' , reste);

        docDefinition = JSON.parse(optionStr);


        if (print) {
          pdfMake.createPdf(docDefinition).print();
        } else {
          if (base64) {
            const pdfDocGenerator = pdfMake.createPdf(docDefinition);
            pdfDocGenerator.getDataUrl((dataUrl) => {
              //$('#pdf').attr('data', dataUrl );
               //this.listPDFArr.push(dataUrl);
                this.listPDFArr.push(docDefinition);
            });
          } else {
            pdfMake.createPdf(docDefinition).download(documentType + '_' + document.reference + '.pdf');
          }
        }
      }, err => {
        // this.toastr.error(`Une erreur s'est produite lors de l'enregistrement` + ': ' + err,  `Erreur`);
      });
  }

  unsafeRedactName(text, name, by) {
    return text.replace(new RegExp('\\$\\{' + name + '\\}', 'g'),  by );
  }

}
